import React, { useState, useContext, useLayoutEffect } from "react"
import PropTypes from "prop-types"

import Navbar from "./Navbar"
import Footer from "./Footer"
import { GlobalContext } from "../pages"

export const ThemeContext = React.createContext("light")

let savedTheme = "light"

const Layout = ({ children }) => {
  const [currentTheme, toggleTheme] = useState(savedTheme)

  useLayoutEffect(() => {
    if (localStorage) {
      const storedTheme = localStorage.getItem("siteTheme")
      if (storedTheme === "light" || storedTheme === "dark") {
        // savedTheme = storedTheme
        toggleTheme(storedTheme)
      } else {
        localStorage.setItem("siteTheme", savedTheme)
      }
    }
  }, [])

  const { backgroundStatus } = useContext(GlobalContext)

  const updateTheme = theme => {
    localStorage.setItem("siteTheme", theme)
    toggleTheme(theme)
  }

  return (
    <ThemeContext.Provider value={currentTheme}>
      {backgroundStatus.status !== "success" ? null : (
        <Navbar theme={currentTheme} toggleTheme={updateTheme} />
      )}
      <main
        style={
          backgroundStatus.status !== "success"
            ? {
                height: "100vh",
                overflow: "hidden",
              }
            : {}
        }
      >
        {children}
      </main>
      {backgroundStatus.status !== "success" ? null : (
        <Footer theme={currentTheme} />
      )}
    </ThemeContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
